export default {
    message: {
        contact: {
            companyNameExample: 'E.g ABC Pte Limited',
            companyNumberLabel: 'Company number',
            companyNumberPlaceholder: 'Company number',
            companyNumberPlaceholderForCompanyMobile: 'Company number',
            ownerNamePlaceholderForCompany: 'Enter the full name of the Company including "Pte Limited"',
            stateRegionLabel: 'City/Region',
        },
        price: {
            tax: 'TAX',
        },
    }
};
